export default {
  name: 'CoreEmptyState',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    buttonLabel: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    commonAttrs: {}
  }),
  computed: {
    hasEmptySlot: function () {
      return Boolean(!this.$slots.default);
    }
  }
};